/*!
=========================================================
* 工事一覧
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardBody, CardTitle, 
  Table, Col,
  FormGroup, Input, Row,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Alert
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import WithRole from '../FormParts/ButtonWithRole';
import ListBaseTree from '../Base/ListBaseTreeUnlimit';
import Definition from '../../common/Definition';
import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputCheckBox from '../FormParts/InputCheckBox'
import InputDatetime from '../FormParts/InputDatetime'
import OptionConvert from '../../common/OptionConvert';
import _ from 'underscore';
import 'moment/locale/ja'
import moment from 'moment/moment'
import { CONSTRUCTION_REGIST,REQUEST_BOX_STATUS } from '../../variables/codes_map';

moment.locale('ja')

moment.updateLocale('ja', {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
});

var domain = "";  

class List extends ListBaseTree {
  default_column = [
    { Header: '工事ID',accessor: 'PROJECT__ulid',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50},
    { Header: '顧客情報（下請）',accessor: '___JOIN_subcontract_customer_information',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '現場名/工事番号/現場担当者',accessor: '___JOIN_project_information',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '現場住所',accessor: '___JOIN_project_addr',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '依頼追加',accessor: 'actions',headerClassName:'text-center',className:'text-center',width:200,minWidth:50, sortable : false},
    // #1198 テスト用コード
    //{ Header: 'テスト',accessor: 'test3',headerClassName:'text-center',className:'text-center',width:100,minWidth:50, sortable : false, add_flg: true },
    
  ];
  default_sub_column = [
    {Header: '依頼',accessor:'___JOIN_REQUEST_ulid_and_box_status',id:'___JOIN_REQUEST_ulid_and_box_status',headerClassName:'sub-table-header',className:'text-left'},
    {Header: '依頼コピー',accessor: 'actionsRequestCopy',headerClassName:'text-center',className:'text-center',width:100,minWidth:50, sortable : false},
    {Header: '依頼削除',accessor: 'actionsRequestDelete',headerClassName:'text-center',className:'text-center',width:100,minWidth:50, sortable : false},
  ];
  default_thr_column = [
    {Header: '見積',accessor:'___JOIN_tree_estimate',id:'___JOIN_tree_estimate',headerClassName:'sub-table-header',className:'text-left'},
    {Header: '見積削除',accessor: 'actionsEstimateDelete',headerClassName:'text-center',className:'text-center',width:100,minWidth:50, sortable : false},
  ];

  constructor(props) {
    super(props);
    // "0":検索, "1":新規顧客
    const is_approved = this.props.box_status !== undefined ? this.props.box_status : "1"
    // 遷移先に遷移元を示すパラメータを渡す
    const box_status_param = `?box_status=${is_approved}`

    Object.assign(this.state, {
      title: '工事一覧',
      message_flg: true,
      add_url: '',
      search_url: '/api/construction/unlimit',
      modal_project_id:"",
      column: this.default_column,
      sub_column:this.default_sub_column,
      thr_column:this.default_thr_column,
      valid: true,
      searchData:{
        values:{
          is_approved : is_approved
        },
        errors:{},
        requiredData:{}
      },
      error:{},
      landmark_user:[],
      landmark_user_branch:[],
      modalData:{
        project_id:'',
        estimateList:[]
      },
      modalCopyData:[],
      information_count:0,
      auto_scroll:true,
      targetRequest : {},
      box_status : is_approved,
      box_status_param : box_status_param,
      customerList : [],
      customerBranchList : [],
      request_delete_modal : false,
      estimate_delete_modal : false,
      request_delete_data: [],
      estimate_delete_data: [],
    });

    this.modalRegist = this.modalRegist.bind(this);
    this.modalExtension = this.modalExtension.bind(this);
    this.modalOther = this.modalOther.bind(this);
    this.modalRequestCopy = this.modalRequestCopy.bind(this);
    this.toggleModalRequestCopy = this.toggleModalRequestCopy.bind(this);
    this.selectCopyData = this.selectCopyData.bind(this);
    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleRequestDeleteModal = this.toggleRequestDeleteModal.bind(this);
    this.toggleEstimateDeleteModal = this.toggleEstimateDeleteModal.bind(this);
    

    this.validateCallback = this.validateCallback.bind(this)

  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.optionsById(res.Data)
      this.setState({landmark_user:user_list});
    })
    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
    // 顧客会社名のリスト取得
    Request.get("/api/customer",{without_limit:true}, res => {
			const customerList = res.Data.map(element=>{
			  return {
          value:element.ulid,
          label:element.customer_name
			  }
			})
			this.setState({customerList});
		})

    this.ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    document.body.style.overflow = "auto";
  }    

  dataMap(data){
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const LinkWithRole = WithRole(Link, this.props.buttons, prop)
      const isAutoOrder = prop.request.some((prop)=>{return prop.auto_order_execution_flag == 1 && prop.auto_order_function_flag == 1}) 
      // 依頼種別が「初回：０」の依頼が存在しない場合、初回とみなす
      const isFirst = prop.isFirst;
      const rowColor =  isAutoOrder ? "bg-lyellow" :  prop.register_type === 1 ? "bg-lblue" : "";
      let message_view = false;
      let {customer_system_start_date,customer_system_end_date,customer_system_use_flag} = prop.customer_user.customer
      let {customer_system_start_date:cb_customer_system_start_date,customer_system_end_date:cb_customer_system_end_date,customer_system_use_flag:cb_customer_system_use_flag} = prop.customer_user.customer_branch
      if(customer_system_use_flag === 1 && cb_customer_system_use_flag === 1 ){
          message_view = true;
      }

      return {
        id: key,
        rowColor: rowColor,
        PROJECT__ulid:(
          <><LinkWithRole button_id="BTN_A1_01_00300" target="_blank" to={"/construction/detail/" + prop.ulid + "?box_status=" + this.state.box_status}>{`${prop.register_type==1 ? "(*)":""}${prop.project_natural_id}`}</LinkWithRole>
           {prop.register_type == 1 && <ButtonWithRole button_id="BTN_A1_01_00341" size="sm" onClick={() => { this.props.history.push('/cumessage/detail/'+prop.project_natural_id) }} className="text-center">問い合わせ確認</ButtonWithRole>}
          </>
          ),
        ___JOIN_project_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_with_site_customer', prop)}} />,
        ___JOIN_project_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
        actions: (<>
                  <ButtonWithRole button_id="BTN_A1_01_00310" size="sm" onClick={() => { this.props.history.push(`/construction/parking/add/${isFirst ? CONSTRUCTION_REGIST.FIRST : CONSTRUCTION_REGIST.ADD}/${prop.ulid}${this.state.box_status_param}`)}} className="text-center">{isFirst ? "初　回" : "追　加"}</ButtonWithRole>
                  <ButtonWithRole button_id="BTN_A1_01_00320" size="sm" onClick={() => { this.modalExtension(prop); }} className="text-center m-1">延　長</ButtonWithRole>
                  <ButtonWithRole button_id="BTN_A1_01_00330" size="sm" onClick={() => { this.props.history.push(`/construction/parking/add/${CONSTRUCTION_REGIST.TRANSSHIPMENT}/${prop.ulid}${this.state.box_status_param}`)}} className="text-center">積　替</ButtonWithRole>
                  <ButtonWithRole button_id="BTN_A1_01_00340" size="sm" onClick={() => { this.modalOther(prop.ulid); }} className="text-center m-1">その他</ButtonWithRole>
                  </>
                ),
        children:this.subDataMap(prop.request,prop.ulid, prop)
      }
    });
  }
  subDataMap(data,ulid,prop){
    const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
    const isCustorder = prop.register_type === 1 
    const {ex_andpad_access_token_key, ex_andpad_quote_file_flag, ex_andpad_use_flag} = prop.customer_user.customer_branch
    const isAndpadUse = prop.ex_andpad_system_id != null && prop.ex_andpad_system_id != "" && prop.register_type === 1 && ex_andpad_use_flag === 1 && ex_andpad_access_token_key != null && ex_andpad_access_token_key != "" ? true : false
    // console.log(data,prop)
    return data.map((prop, key) => {
      // console.log(prop);
      const isAutoOrder = prop.auto_order_execution_flag == 1 && prop.auto_order_function_flag == 1
      // 初回、追加、積替のみ依頼コピー可能
      const copyableRequestFlag = prop.request_type == 0 || prop.request_type == 1 || prop.request_type == 3 ? true : false
      const isCheckNg = prop.request_box_status == REQUEST_BOX_STATUS.CHECK_NG
      let apdpadEstimates = prop.estimate.filter(est => est.ex_andpad_estimate_delete_flag == 0 && est.ex_andpad_plotting_delete_flag == 0)
      // console.log(prop.request_box_status == REQUEST_BOX_STATUS.CHECK_NG , prop.request_box_status,REQUEST_BOX_STATUS.CHECK_NG)

      let estimate = prop.estimate[0]

      // 対象ステータスは、調査完了 または　依頼キャンセル　かつ　調査見積送付済、受注、確定見積送付済、失注（自動）、失注（手動）のもの
      const copyFlag = copyableRequestFlag && (prop.survey_status == 3  && estimate.estimate_status >= 3) || (prop.survey_status == 10 && estimate.estimate_status >= 2)? true : false;
      
      // 依頼、見積もりの削除ボタン制御
      const deleteDisabled = {
        payment_done: false,
      };
      // console.log(prop);
      prop.estimate.forEach((est)=>{
        // 「駐車場」
        if(prop.request_type < 4){
          // 売掛金があるか?->仕入済みか？
          // console.log(est)
          if(est.accounts_receivable_collection_flag != null){
            deleteDisabled[est.estimate_natural_id] = true;
            // 仕入れ済みでない&売掛金が未回収の場合、削除可能
            prop.payment.forEach((payment,i) => {
              if(payment.estimate_natural_id == est.estimate_natural_id && payment.payment_status != 4 && est.accounts_receivable_collection_flag == 0){
                deleteDisabled[payment.estimate_natural_id] = false;
              }
            })
          }else{
            deleteDisabled[est.estimate_natural_id] = false;
            // 仕入実施済みの場合、非活性
            // 請求キャンセルを除外
            prop.payment.forEach((payment) => {
              if(payment.estimate_natural_id == est.estimate_natural_id && payment.payment_status == 4 && est.estimate_status != 8){
                deleteDisabled[est.estimate_natural_id] = true;
              }
            })
          }

        //「その他」
        }else{
          deleteDisabled[est.estimate_natural_id] = prop.request_other_status == 6 ? true : false
        }

      })
      // どれか一つでも条件を満たしていなかったら、非活性
      Object.values(deleteDisabled).forEach((value)=> {
        if(value == true){
          deleteDisabled.payment_done = true
        }
      })
      // console.log(deleteDisabled);

      prop = {
        ...prop,
        box_status_param : this.state.box_status_param
      }
      console.log("prop ", prop)
        return {
          _PROJECT__ulid:ulid,
          // rowColor: isCheckNg ? "bg-lred": isCustorder ? "bg-lblue": "",
          rowColor: isAutoOrder ? "bg-lyellow" :  isCustorder ? "bg-lblue": "bg-lwhite",
          id: key,
          ___JOIN_REQUEST_ulid_and_box_status: (prop.request_type < 4 ? <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_REQUEST_ulid_and_box_status', prop)}} /> : <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_REQUEST_ulid_other_and_box_status', prop)}} />),
          children:this.thrDataMap(prop.estimate,prop.ulid,prop.parking,isAutoOrder,isCustorder,prop.request_type, deleteDisabled, isAndpadUse),
          actionsRequestCopy:(
            copyFlag && <ButtonWithRole 
              button_id="BTN_A1_01_00345" 
              size="sm" 
              onClick={() => { this.modalRequestCopy(prop, ulid); }} 
              className="text-center m-1">コピー
            </ButtonWithRole>
          ),
          actionsRequestDelete:(
            <ButtonWithRole 
              button_id="BTN_A1_01_00346" 
              size="sm" 
              onClick={() => { this.toggleRequestDeleteModal(prop, ulid, isAndpadUse, apdpadEstimates); }} 
              disabled={deleteDisabled.payment_done}
              className="text-center m-1">削除
            </ButtonWithRole>
          ),
        }

    });
  }
  thrDataMap(data,ulid,parking,isAutoOrder,isCustorder,request_type,deleteDisabled,isAndpadUse){
    return data.map((prop, key) => {
      // console.log("estimate ", prop)
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      prop.parking = parking[key];
      // console.log(deleteDisabled[prop.estimate_natural_id] , !prop.id,deleteDisabled[prop.estimate_natural_id] || !prop.id);
      return {
        __PROJECT__ulid:ulid,
        rowColor: isAutoOrder ? "bg-lyellow" : isCustorder ? "bg-lblue": "",
        id: key,
        ___JOIN_tree_estimate:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_tree_estimate', prop)}} />,
        actionsEstimateDelete: request_type < "4" && prop.estimate_status > 2 ? (
          <ButtonWithRole 
            button_id="BTN_A1_01_00347" 
            size="sm" 
            onClick={() => { this.toggleEstimateDeleteModal(prop, ulid, isAndpadUse); }}
            disabled={deleteDisabled[prop.estimate_natural_id] || !prop.id}
            className="text-center m-1">削除
          </ButtonWithRole>
        ):"",
      }
    });
  }
  
  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }
    /*
    * 新規登録用モーダル表示
    */
    modalRegist(){
      this.setState({
        modalRegist: !this.state.modalRegist
      });
    }
    /*
    * 延長用モーダル表示
    */
    modalExtension(prop){
      if (this.state.modalExtension){
        this.setState({
          modalExtension:!this.state.modalExtension,
        })
        return
      }
      const {
        ulid:project_ulid,
        project_natural_id
      } = prop
      // this.searchProject(project_id);
      const api = '/api/order'
      const params ={
        project_natural_id,
        extension_flag:1,
        request_type:[CONSTRUCTION_REGIST.FIRST,CONSTRUCTION_REGIST.ADD,CONSTRUCTION_REGIST.EXTENSION,CONSTRUCTION_REGIST.TRANSSHIPMENT] // 0:初回、1:追加、2:延長、3:積替、4:道路使用許可、5:取扱説明書収納、6:電線移設
      }
      Request.get(api, params, (res)=>{
        this.setState({
          modalExtension: !this.state.modalExtension,
          modalData:{
            project_ulid,
            estimateList:res.Data
          }
        });
      })
    }
    /*
    * その他用モーダル表示
    */
    modalOther(project_id){
      this.setState({
        modalOther: !this.state.modalOther,
        modal_project_id: project_id
      });
    }

    // 依頼コピーモーダル
    modalRequestCopy(prop, ulid){
//      console.log("prop ", prop)
      const params ={
        project_natural_id : prop.project_natural_id,
        copy_extention_flag: 1,
        survey_status : "3,10", // （デフォルト）0:未調査、1:Web調査、2:現地調査、3:調査完了（調査見積送付）、9:調査途中終了（調査見積未送付）、10:依頼キャンセル（調査見積未送付）
        request_natural_id : prop.request_natural_id,
        // request_type:[0,1,2] // 0:初回、1:追加、2:延長、3:積替、4:道路使用許可、5:取扱説明書収納、6:電線移設
      }

      Request.get('/api/order', params, (res)=>{
        const modalCopyData = res.Data.map(item => ({
          ...item,
          copy_flg : true
        }))
        this.setState({
            modalCopyData: modalCopyData,
            copy_modal:!this.state.copy_modal,
            targetRequest : {
              ...prop,
              project_ulid : ulid // projectのulid追加
            }
        });
      })
    }
    // トグル依頼コピーモーダル
    toggleModalRequestCopy(){
      this.setState({
        copy_modal:!this.state.copy_modal,
      })
      return
    }

    selectCopyData() {
      const copy_data = this.state.modalCopyData.filter((data)=>data.copy_flg==true)
      if(copy_data.length < 1){
        this.props.alertModal.current.showErrorModal({messageNo:2489});
        return;
      }

      this.toggleRegistModal()
    }
    searchProject(ulid){
      let params = {
        ulid: ulid
      };

      this.search_count(); // #1189 - 2021/7/19 

      var url = domain + '/api/construction/unlimit'; // #1189 - 2021/7/19 
      Request.get(url, {
        ulid: params.ulid,
        limit : this.state.paging.limit,
        offset: this.state.paging.index
      }, res => {
//        console.log(res);
        for (var d in res.data) {
          if (ulid == res.data[d]["PROJECT__ulid"]) {
            var data = res.data[d];
          }
        }
        this.setState({ edit_data: data,view:true });
      }
      );
    } 
  /* #1189 - 2021/7/19 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
//      console.log(res.data);
      this.setState({data_count: res.Data});
    })
  }

  async validateCallback(newData, callback=()=>{}){
    if(newData.values.customer_name != undefined || newData.values.customer_ulid != undefined){
      // 顧客会社名
			const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.customer_ulid)>-1)
			? {
			  customer_ulid: newData.values.customer_ulid,
			  customer_name: undefined
			} : {
			  customer_ulid:undefined,
			  customer_name: (newData.values.customer_ulid != undefined)?newData.values.customer_ulid:newData.values.customer_name
			}
      
      // 顧客支店名リスト（詳細検索：顧客会社名でリスト選択時に顧客支店名のリスト取得）
			const customerBranchList = this.state.searchData.values.customer_ulid!=customerParam.customer_ulid
			? (customerParam.customer_ulid
			  ? await new Promise(resolve=>{
				Request.get("/api/customer/branch",{
				  customer_ulid:customerParam.customer_ulid,
				  customer_branch_delete_flag : 1
				}, res => {
				  resolve(res.Data.map(element=>{
					return {
					  value:element.ulid,
					  label:element.customer_branch_name
					}
				  })) 
				})
			  })
			  : [])
			: this.state.customerBranchList
			const customerBranchParam = this.state.searchData.values.customer_ulid==customerParam.customer_ulid
			? (customerBranchList.findIndex(customer=>customer.value==newData.values.customer_branch_ulid)>-1)
			  ? {
				customer_branch_ulid: newData.values.customer_branch_ulid,
				customer_branch_name: undefined
			  }
			  : {
				customer_branch_ulid: undefined,
				customer_branch_name: (newData.values.customer_branch_ulid != undefined)? newData.values.customer_branch_ulid:newData.values.customer_branch_name
			  }
			: {
			  customer_branch_ulid: undefined,
			  customer_branch_name: undefined
			}

      this.setState({
			  searchData:{
				...this.state.searchData,
				...newData,
				values:{
					...this.state.searchData.values,
					...newData.values,
					...customerParam,
					...customerBranchParam
				}
			  },
			  customerBranchList
			}, ()=>callback())
    }else{
			this.setState({
				searchData:{
				  ...this.state.searchData,
				  ...newData,
				  values:{
					  ...this.state.searchData.values,
					  ...newData.values,
				  }
				},
			  }, ()=>callback())
		}
  }
  
  search_field_cols() {
//    console.log('state', this.state)
    return (
      <>
        <Col md="3">
          <InputText
            label='工事ID'
            name='PROJECT__project_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='顧客担当者TEL'
            name='CUSTOMER_USER__customer_user_tel'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='仕入先TEL'
            name='ESTIMATE__supplier_tel'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    const ButtonWithTooltipWithRole = this.ButtonWithTooltipWithRole || WithRole(ButtonWithTooltip, this.props.buttons)
    return (
    <>
      <Col md="6">
        <ButtonWithTooltipWithRole
          onclick={() => {this.modalRegist(); }}
          class="float-right btn-search btn-facebook"
          id="tmp"
          icon="fas fa-plus"
          label="新規登録"
          message="データを追加"
          button_id="BTN_A1_01_00110"
        />
      </Col>
    </>
    );
  }
  message_search_field_cols () {
    return (
      <>
      <Col md="3"></Col>
      <Col md="3">
        <InputCheckBox
          label='問い合わせ未読あり'
          name='CUSTOMER_MESSAGE__already_read'
          validateCallback={this.validateCallback} 
          checkedValue={1}
          uncheckedValue={0}
          rootData={this.state.searchData}
          validateType={'search'}
        />
       </Col>
       </>
    );
  }

  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<>
          <Col md="3">
          <FormGroup>
            <InputSelect label="ランドマーク支店"
              name="USER_BRANCH__user_branch_natural_id"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              options={this.state.landmark_user_branch}
              enterSearch={true}
              enterCallback={this.searchWithPageIndex}
              rootData={this.state.searchData} />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
          <InputSelect label="調査担当者"
              name="REQUEST__onsite_survey_account"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              options={this.state.landmark_user}
              enterSearch={true}
              enterCallback={this.searchWithPageIndex}
              isSearchable={true}
              rootData={this.state.searchData} />
          </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <InputSelect label="発注担当者"
                name="ESTIMATE__contract_user_id"
                labelOn={true} 
                validateCallback={this.validateCallback} 
                options={this.state.landmark_user}
                enterSearch={true}
                enterCallback={this.searchWithPageIndex}
                isSearchable={true}
                rootData={this.state.searchData} />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <InputSelect label="仕入担当者"
                name="ESTIMATE__payment_user_id"
                labelOn={true} 
                validateCallback={this.validateCallback} 
                options={this.state.landmark_user}
                enterSearch={true}
                enterCallback={this.searchWithPageIndex}
                isSearchable={true}
                rootData={this.state.searchData} />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <InputSelect
                label="顧客会社名"
                labelOn={true}
                name="CUSTOMER__customer_ulid"
                options={this.state.customerList}
                validateCallback={this.validateCallback} 
                validateType='search'
                isSearchable={true}
                isCreatable={true}
                rootData={this.state.searchData}
                searchStartLength={2}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <InputSelect
                label="顧客支店名"
                labelOn={true}
                key={`customer_branch_${this.state.searchData.values.customer_customer_ulid}`}
                name="CUSTOMER_BRANCH__customer_branch_ulid"
                options={this.state.customerBranchList}
                validateCallback={this.validateCallback} 
                validateType='search'
                rootData={this.state.searchData}
                isSearchable={true}
                isCreatable={true}
              />
            </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='工事番号'
              name='PROJECT__construction_number'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='現場名'
              name='PROJECT__site_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='現場所在地'
              name='PROJECT__site_location'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先名'
              name='ESTIMATE__supplier_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場名'
              name='ESTIMATE__survey_parking_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場所在地（ 住所の方 ）'
              name='ESTIMATE__survey_parking_location'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（FROM）'
              name='ESTIMATE__request_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（TO）'
              name='ESTIMATE__request_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出日（FROM）'
              name='ESTIMATE__estimate_filling_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出日（TO）'
              name='ESTIMATE__estimate_filling_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約開始日（FROM）'
              name='ESTIMATE__quote_available_start_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約開始日（TO）'
              name='ESTIMATE__quote_available_start_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約終了日（FROM）'
              name='ESTIMATE__quote_available_end_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約終了日（TO）'
              name='ESTIMATE__quote_available_end_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputCheckBox label="終了済みのデータを表示しない"
              name="ESTIMATE__estimate_status" 
              validateCallback={this.validateCallback} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
              />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputCheckBox label="失注および請求キャンセル"
              name="ESTIMATE__estimate_status_lost_order" 
              validateCallback={this.validateCallback} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
              />
          </FormGroup>
          </Col>
      </>);
  }
  checkbox_field_cols(){
    return (
      <></>
    );
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal
    });
  }

  toggleRequestDeleteModal(prop,ulid, isAndpadUse, apdpadEstimates) {
    this.setState({
      request_delete_modal: !this.state.request_delete_modal,
      request_delete_data: prop,
      isAndpadUse: isAndpadUse,
      apdpadEstimates: apdpadEstimates
    });
  }  

  toggleEstimateDeleteModal(prop,ulid, isAndpadUse) {
    this.setState({
      estimate_delete_modal: !this.state.estimate_delete_modal,
      estimate_delete_data: prop,
      isAndpadUse: isAndpadUse == true && prop.ex_andpad_estimate_delete_flag == 0 && prop.ex_andpad_plotting_delete_flag == 0 ? true : false,
      apdpadEstimates: []
    });
  }  


  registEstimateCopy(){
    const copy_data = this.state.modalCopyData.filter((data)=>data.copy_flg==true)
    let estimate_ids = copy_data.map((cd)=>{return cd.estimate_natural_id});
//    console.log("target ids ", estimate_ids)
    const { 
      request_type,
      survey_estimate_status
    } = this.state.targetRequest
    const params = {
      ...this.state.targetRequest,
      request_natural_id : undefined,
      request_type : request_type == 0 ? 1 : request_type, // 初回のコピーは追加として登録する
      extend_estimate_natural_id : estimate_ids.join(","),
      survey_status : survey_estimate_status, // 見積登録時に選択した調査ステータス
      estimate_copy_flag : 1, // 見積コピーフラグ
      estimate_all_copy_flag : this.state.modalCopyData.length == copy_data.length? 1 : 0
    }
    Request.post("/api/request", params, (res) => {
      this.props.alertModal.current.confirmCheck({
        messageNo:2417,
        closeBtn: false
      },() => {
        this.props.alertModal.current.toggleErrorModal();
        this.toggleRegistModal(); 
        this.toggleModalRequestCopy();
        this.search()
      }, false);
    });
    document.body.style.overflow = "auto";
  }

  andpad_message(estimetes) {
    // console.log(estimetes)
    if(estimetes.length > 0) {
      let andpad_estimates = estimetes.map((est)=>{return "見積ID:"+est+"<br />"})
      return "<div style='margin-top: 10px; line-height: 1; font-size: 20px; color: red; text-align: left;'>ANDPADにファイルが連携されています<br />工事詳細画面_確定見積送付ツリーダイアログ<br />からファイルを削除してください<br /><br />"+andpad_estimates.join("")+"</div>";
    }
  }

  async request_delete() {
    const {request_natural_id} = this.state.request_delete_data;
    console.log(this.state.request_delete_data,request_natural_id);

    if(request_natural_id == undefined) {
      return false;
    }

    const deleteUrl = '/api/request/delete'
    const deleteData = {request_natural_id}
    Request.post(deleteUrl, deleteData, res=>{
      document.body.style.overflow = "auto";
      if (res.Code == 819){
        this.props.alertModal.current.confirmCheck({
          title: "削除エラー",
          message: this.andpad_message(res.Data.estimate_natural_ids),
          closeBtn: false
        }, ()=>{
          this.search()
        }, false)
      }else{
        this.props.alertModal.current.confirmCheck({
          title: "更新が完了しました。",
          messageNo: 2507,
          closeBtn: false
        }, ()=>{
          this.search()
        }, false)

      }
    })

  }


  async estimate_delete() {

    const {estimate_natural_id} = this.state.estimate_delete_data;

    if(estimate_natural_id == undefined) {
      return false;
    }
    console.log(this.state.estimate_delete_data,estimate_natural_id);

    const deleteUrl = '/api/estimate/delete'
    const deleteData = {estimate_natural_id}
    Request.post(deleteUrl, deleteData, res=>{
      document.body.style.overflow = "auto";

      if (res.Code == 819){
        this.props.alertModal.current.confirmCheck({
          title: "削除エラー",
          message: this.andpad_message(res.Data.estimate_natural_ids),
          closeBtn: false
        }, ()=>{
          this.search()
        }, false)
      }else{

        this.props.alertModal.current.confirmCheck({
          title: "更新が完了しました。",
          messageNo: 2507,
          closeBtn: false
        }, ()=>{
          this.search()
        }, false)

      }
    })
  }  

  dialog_defines() {
    const modalData = this.state.data.find(element=>element.project_id==this.state.modal_project_id)
    const ButtonWithRole = WithRole(Button, this.props.buttons, modalData)
    
    return (
      <>
       <Modal isOpen={this.state.modalRegist} toggle={this.modalRegist} size="lg">
          <ModalHeader className="justify-content-center" toggle={this.modalRegist}>
            新規登録する依頼の種別を選択してください
          </ModalHeader>
          <ModalBody>
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="float-left">駐車場</CardTitle><br /><br /><br />
              <ButtonWithRole button_id="BTN_A1_01_00400" color="info" onClick={()=>{this.props.history.push(`/construction/add/${CONSTRUCTION_REGIST.FIRST}${this.state.box_status_param}`)}}>初回</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00410" color="info" onClick={()=>{this.props.history.push(`/construction/add/${CONSTRUCTION_REGIST.TRANSSHIPMENT}${this.state.box_status_param}`)}}>積替用地</ButtonWithRole>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="float-left">その他サービス</CardTitle><br /><br /><br />
              <ButtonWithRole button_id="BTN_A1_01_00420" color="info" onClick={()=>{this.props.history.push(`/construction/add/${CONSTRUCTION_REGIST.PERMISSION_ROAD_USAGE}${this.state.box_status_param}`)}}>道路使用許可</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00430" color="info" onClick={()=>{this.props.history.push(`/construction/add/${CONSTRUCTION_REGIST.STORE_MANUAL}${this.state.box_status_param}`)}}>取扱説明書収納</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00440" color="info" onClick={()=>{this.props.history.push(`/construction/add/${CONSTRUCTION_REGIST.RELOCATION_WIRE}${this.state.box_status_param}`)}}>電線移設</ButtonWithRole>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
            <Button className="pos_center" onClick={this.modalRegist}>
              キャンセル
            </Button>
            </CardBody>
          </Card>

          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.modalExtension} toggle={this.modalExtension} size="lg">
          <ModalHeader className="justify-content-center" toggle={this.modalExtension}>
            依頼を「延長」で追加します。<br />
            延長する駐車場を選択してください。
          </ModalHeader>
          <CardBody style={{overflowY: 'auto', height: '500px'}}>
             <Table className="tablesorter" >
                <thead className="text-primary">
                  <tr>
                    <th className="text-center">見積ID</th>
                    <th className="text-center">駐車場名</th>
                    <th className="text-center">駐車場住所</th>
                    <th className="text-center">電話番号</th>
                    <th className="text-center">車種別利用可否</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {
                  this.state.modalData.estimateList.length>0&&
                  this.state.modalData.estimateList.map((estimate)=>{
                    const {
                      estimate_natural_id,
                      survey_parking_name,
                      survey_parking_prefecture:parking_prefecture,
                      survey_parking_city:parking_city,
                      survey_parking_address:parking_address,
                      supplier_tel,
                      survey_capacity_flag_car:capacity_flag_car,
                      survey_capacity_flag_light_truck:capacity_flag_light_truck,
                      survey_capacity_flag_truck:capacity_flag_truck
                    } = estimate
                    
                    const parkingAddress = <div 
                      dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_addr', {
                        parking_prefecture,
                        parking_city,
                        parking_address
                      })}} 
                    />
                    const parkingCapacityFlags = <div 
                      dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_capacity_flags', {
                        capacity_flag_car,
                        capacity_flag_light_truck,
                        capacity_flag_truck
                      })}} 
                    />
                    return <tr>
                      <td>{estimate_natural_id}</td>
                      <td>{survey_parking_name}</td>
                      <td>{parkingAddress}</td>
                      <td>{supplier_tel}</td>
                      <td>{parkingCapacityFlags}</td>
                      <td>
                        <Link to={`/construction/parking/add/${CONSTRUCTION_REGIST.EXTENSION}/` + this.state.modalData.project_ulid + "/" + estimate_natural_id + "?box_status=" + this.state.box_status}>
                        <Button className="btn-sm" onClick={this.modalExtension}>
                        選択
                        </Button>
                        </Link>
                      </td>
                    </tr>
                  })
                  }
                </tbody>
              </Table>                
          </CardBody>
          <ModalBody>
          <Card>
            <CardBody>
            <Button className="pos_center" onClick={this.modalExtension}>
              キャンセル
            </Button>
            </CardBody>
          </Card>
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.modalOther} toggle={this.modalOther} size="lg">
        <ModalHeader className="justify-content-center" toggle={this.modalOther}>
          「その他サービス」の依頼を追加します。<br />
          追加するサービスを選択してください。
        </ModalHeader>
          <ModalBody>
          <Card>
            <CardBody>
              <CardTitle tag="h4" className="float-left">その他サービス</CardTitle><br /><br /><br />
              <ButtonWithRole button_id="BTN_A1_01_00480" color="info" onClick={()=>{this.props.history.push(`/construction/other/add/${CONSTRUCTION_REGIST.PERMISSION_ROAD_USAGE}/${this.state.modal_project_id}${this.state.box_status_param}`)}}>道路使用許可</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00490" color="info" onClick={()=>{this.props.history.push(`/construction/other/add/${CONSTRUCTION_REGIST.STORE_MANUAL}/${this.state.modal_project_id}${this.state.box_status_param}`)}}>取扱説明書収納</ButtonWithRole>&nbsp;
              <ButtonWithRole button_id="BTN_A1_01_00500" color="info" onClick={()=>{this.props.history.push(`/construction/other/add/${CONSTRUCTION_REGIST.RELOCATION_WIRE}/${this.state.modal_project_id}${this.state.box_status_param}`)}}>電線移設</ButtonWithRole>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
            <Button className="pos_center" onClick={this.modalOther}>
              キャンセル
            </Button>
            </CardBody>
          </Card>

          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.copy_modal} toggle={this.toggleModalRequestCopy} size="lg">
        {this.state.modalCopyData.length>0?(<>
          <ModalHeader className="justify-content-center" toggle={this.toggleModalRequestCopy}>
            再見積する見積を選択してください。
          </ModalHeader>
          <CardBody style={{overflowY: 'auto', height: '500px'}}>
             <Table className="tablesorter" >
                <thead className="text-primary">
                <tr>
                  <th className="text-center"></th>
                  <th className="text-center">見積ID</th>
                  <th className="text-center">駐車場名</th>
                  <th className="text-center">駐車場住所</th>
                  <th className="text-center">電話番号</th>
                  <th className="text-center">車種別利用可否</th>
                </tr>
                </thead>
                <tbody>
                {this.state.modalCopyData.map((modal_data, n)=>{
                    const {
                      parking_id,
                      parking_natural_id,
                      estimate_natural_id,
                      survey_parking_name,
                      survey_parking_prefecture:parking_prefecture,
                      survey_parking_city:parking_city,
                      survey_parking_address:parking_address,
                      supplier_tel,
                      survey_capacity_flag_car:capacity_flag_car,
                      survey_capacity_flag_light_truck:capacity_flag_light_truck,
                      survey_capacity_flag_truck:capacity_flag_truck
                    } = modal_data
                    
                    const parkingAddress = <div 
                      dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_addr', {
                        parking_prefecture,
                        parking_city,
                        parking_address
                      })}} 
                    />
                    const parkingCapacityFlags = <div 
                      dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_capacity_flags', {
                        capacity_flag_car,
                        capacity_flag_light_truck,
                        capacity_flag_truck
                      })}} 
                    />

                  return (<tr>
                    <td>
                      <Input
                        name={"copydata["+ n +"]"}
                        type="checkbox"
                        value={n}
                        defaultChecked={true}
                        disabled={(modal_data.disabled != undefined)? modal_data.disabled: false}
                        onClick={(e)=>{
                          let n = e.target.value;
                          let selectParkingId = null;
                          let selectData = this.state.modalCopyData[n];
                          selectParkingId = selectData.parking_natural_id
                          let newmodalCopyData = this.state.modalCopyData.map((data,i)=>{
                            // 選択されたデータの処理
                            if (i == n) {
                              return {...data, copy_flg:!data.copy_flg, disabled: false }
                            }
                            //　それ以外
                            else {
                              return data;
                            }
                          });
                          this.setState({modalCopyData:newmodalCopyData});
                        }}
                      />
                    </td>
                    <td>{estimate_natural_id}</td>
                    <td>{survey_parking_name}</td>
                    <td>{parkingAddress}</td>
                    <td>{supplier_tel}</td>
                    <td>{parkingCapacityFlags}</td>
                  </tr>);
                })}
                </tbody>
            </Table>
          </CardBody>
          <ModalBody>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <Button className="pos_center" onClick={this.toggleModalRequestCopy}>キャンセル</Button>
                  </Col>
                  <Col>
                    <Button className="btn btn-info pos_center" onClick={()=>{this.selectCopyData()}}>選択</Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </ModalBody>
        </>):(<>
          <ModalHeader className="justify-content-center" toggle={this.toggleModalRequestCopy}>
            該当する見積がありません。
          </ModalHeader>
          <ModalBody>
            <Card>
              <CardBody>
              <Button className="pos_center" onClick={this.toggleModalRequestCopy}>閉じる</Button>
              </CardBody>
            </Card>
          </ModalBody>
        </>)}
     </Modal>

     <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{"見積コピー"}</h5>
          </div>
          <ModalBody>
            <p>選択した見積をコピーします。よろしいですか</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole 
            color="info" 
            onClick={() => { this.registEstimateCopy(); }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.request_delete_modal} toggle={this.toggleRequestDeleteModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRequestDeleteModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">データ削除</h5>
          </div>
          <ModalBody>
            <p>案件「{this.state.request_delete_modal == true && this.state.request_delete_data.request_natural_id != undefined &&this.state.request_delete_data.request_natural_id}」を削除します。よろしいですか？</p>
          {
              this.state.isAndpadUse && this.state.apdpadEstimates.length > 0 && (
                <div style={{marginTop: "10px", lineHeight: "1", fontSize: "20px", color: "red", textAlign: "left"}}>
                  ANDPADにファイルが連携されています<br />
                  工事詳細画面_確定見積送付ツリーダイアログ<br />
                  からファイルを削除してください<br />
                  {this.state.apdpadEstimates && this.state.apdpadEstimates.map((item, index) => {
                    return (
                      <div style={{marginTop: "10px", fontSize: "20px"}} key={index}>見積ID:&nbsp;{item.estimate_natural_id}</div>
                    )
                  })}
                </div>
              )
          }
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRequestDeleteModal}>
              いいえ
            </Button>
            <ButtonWithRole
              color="info" 
              onClick={() => {this.toggleRequestDeleteModal(); this.request_delete()}}
              disabled={this.state.isAndpadUse && this.state.apdpadEstimates.length > 0}
              >
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.estimate_delete_modal} toggle={this.toggleEstimateDeleteModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleEstimateDeleteModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">データ削除</h5>
          </div>
          <ModalBody>
            <p>見積「{this.state.estimate_delete_modal == true && this.state.estimate_delete_data.estimate_natural_id != undefined && this.state.estimate_delete_data.estimate_natural_id}」を削除します。よろしいですか？</p>
          {
              this.state.isAndpadUse && (
                <div style={{marginTop: "10px", lineHeight: "1", fontSize: "20px", color: "red", textAlign: "left"}}>
                  ANDPADにファイルが連携されています<br />
                  工事詳細画面_確定見積送付ツリーダイアログ<br />
                  からファイルを削除してください<br />
                  <div style={{marginTop: "10px", fontSize: "20px"}} >見積ID:&nbsp;{this.state.estimate_delete_modal == true && this.state.estimate_delete_data.estimate_natural_id != undefined && this.state.estimate_delete_data.estimate_natural_id}</div>
                </div>
              )
          }
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleEstimateDeleteModal}>
              いいえ
            </Button>
            <ButtonWithRole
              color="info" 
              onClick={() => {this.toggleEstimateDeleteModal(); this.estimate_delete()}}
              disabled={this.state.isAndpadUse}
              >
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>        
     </>
    );
  }   
}
 
export default List
